import { useQuery, UseQueryOptions } from '@tanstack/react-query'
import { Entities } from 'src/enums'
import { GatewayState } from 'src/api'
import { useApiInstance } from './useApiInstance'

interface RequestParams {
  options?: Omit<UseQueryOptions<unknown, Error, GatewayState[]>, 'queryKey' | 'queryFn'>
}

export const useGatewayStatesRequest = ({ options }: RequestParams = {}) => {
  const api = useApiInstance()
  return useQuery<unknown, Error, GatewayState[]>(
    [Entities.GatewayState],
    async () => {
      const { data } = await api.v1AdminGatewaysStatesGet()
      return data || []
    },
    { ...options }
  )
}
